import tag from "html5-tag";

export const editableLayers = [
  "point",
  "line_string",
  "multi_line_string",
  "polygon",
  "multi_polygon",
  "nodes",
  "zones",
  "links",
  "connectors",
  "stop_points"
];

export const getDsGeomType = function(geomType) {
  switch (geomType) {
    case "line_string":
    case "multi_line_string":
      return "line";
    case "polygon":
    case "multi_polygon":
      return "polygon";
    case "point":
    case "multi_point":
      return "point";
    default:
      return "layer";
  }
};

export const renderToolsItem = (e, data) =>
  tag(
    "span",
    {
      class: `ritm-tree__tools-item ${e}`,
      children: `${data.children.length}`,
      "data-type": data.datatype,
      "data-source-id": data.source_id,
      "data-id": data.id,
      "geom-type": data.geom_type,
      "node-type": `${e}`,
      "node-name": data.name
    },
    ""
  );

export const findActive = (state, node, module, deep) => {
  if (node.state && node.state.open && !deep) return false;
  let result;

  if (node.children.length) {
    result = node.children.find(e => {
      if (module === "mapTree" && state.isActive(e.source_id)) {
        return true;
      } else if (
        module !== "mapTree" &&
        isLayerActive(state.activeLayersId, e.id)
      ) {
        return true;
      } else if (e.children) {
        return findActive(state, e, module, true);
      }
    });
  }

  return !!result;
};

export const isLayerActive = (activeId, id) => activeId === id;
